import { ReactElement, useCallback, useState } from 'react'
import ReactDOMServer from 'react-dom/server'
import { MemoryRouter } from 'react-router-dom'
import { ServerStyleSheet } from 'styled-components'
import { generate } from '../../externals/api/generatePdf'

type UsePrint = {
  print: (element: ReactElement) => Promise<void>
  isLoading: boolean
}

export const usePrint = (): UsePrint => {
  const [isLoading, setIsLoading] = useState(false)

  const print = useCallback(async (element: ReactElement) => {
    setIsLoading(true)
    try {
      const sheet = new ServerStyleSheet()

      const jsx = sheet.collectStyles(
        <MemoryRouter
          initialEntries={['/']}
        >
          {element}
        </MemoryRouter>
      )

      const initialHtml = ReactDOMServer.renderToStaticMarkup(jsx)

      const styleTags = sheet.getStyleTags()
      sheet.seal()

      const html = (`
        <style>.button {display: none;}; ${styleTags}</style>
        ${initialHtml}
      `).replace(/\/static/gi, `${window.location.origin}/static`)

      await generate({ html })
    } catch (err) {
      console.log('RR', err)
    }
    setIsLoading(false)
  }, [setIsLoading])

  return { print, isLoading }
}
